export default __webpack_public_path__ + "static/media/invoice.a00a1e3d.png";